package horcrux.frontend.common.views.navigation

import horcrux.frontend.common.views.feedbackform.FeedbackFormDialog
import horcrux.frontend.common.GlobalAppState
import horcrux.frontend.common.Route
import horcrux.frontend.common.analytics.ScreenViewEvent
import horcrux.frontend.common.configs.StaticContentConfigs.APP_BAR_HEIGHT
import horcrux.frontend.common.set
import mui.icons.material.Feedback
import mui.material.AppBar
import mui.material.AppBarPosition
import mui.material.Box
import mui.material.Grid
import mui.material.Slide
import mui.material.SlideDirection
import mui.material.Toolbar
import mui.material.styles.Theme
import mui.material.styles.useTheme
import mui.material.useScrollTrigger
import mui.system.sx
import react.FC
import react.Props
import react.ReactNode
import react.create
import react.dom.aria.ariaLabel
import react.useState
import web.cssom.AlignItems
import web.cssom.JustifyContent
import web.cssom.ZIndex
import web.cssom.px

private external interface HideOnScrollProps : Props {
    var children: ReactNode
}

private val HideOnScroll = FC<HideOnScrollProps> { props ->
    val trigger = useScrollTrigger()
    Slide {
        this.appear = false
        this.direction = SlideDirection.down
        this.`in` = !trigger
        +props.children
    }
}

external interface NavigationBarProps : Props {
    var route: Route
    var globalAppState: GlobalAppState
}

val NavigationBar = FC<NavigationBarProps> { props ->
    val showFeedbackFormDialogState = useState(false)
    val theme: Theme = useTheme()

    FeedbackFormDialog {
        this.showDialogState = showFeedbackFormDialogState
        this.globalAppState = props.globalAppState
    }

    HideOnScroll {
        this.children = Box.create {
            sx {
                this.marginBottom = 10.px
            }
            AppBar {
                this.position = AppBarPosition.fixed
                this.sx {
                    this.zIndex = (theme.zIndex.drawer.toInt() + 1).unsafeCast<ZIndex>()
                    this.height = APP_BAR_HEIGHT
                }
                Toolbar {
                    Grid {
                        this.container = true
                        this.sx {
                            this.justifyContent = JustifyContent.spaceBetween
                            this.alignItems = AlignItems.center
                        }
                        Grid {
                            this.item = true
                            NavigatorButton {
                                this.route = props.route
                                this.globalAppState = props.globalAppState
                            }
                        }

                        if (props.route.shouldShowCollectionNavigatorButton()) {
                            Grid {
                                this.item = true
                                ShowCollectionNavigatorButton {
                                    this.globalAppState = props.globalAppState
                                }
                            }
                        }

                        Grid {
                            this.item = true
                            Feedback {
                                this.ariaLabel = "Tell us what you think"
                                this.onClick = {
                                    showFeedbackFormDialogState.set(true)
                                    props.globalAppState.analyticsClient.log(ScreenViewEvent.FEEDBACK_FORM)
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
